

import {
  FETCH_PRINTER_REQUEST,
  FETCH_PRINTER_SUCCESS,
  FETCH_PRINTER_FAILURE,
  CREATE_PRINTER_REQUEST,
  CREATE_PRINTER_SUCCESS,
  CREATE_PRINTER_FAILURE,
  UPDATE_PRINTER_REQUEST,
  UPDATE_PRINTER_SUCCESS,
  UPDATE_PRINTER_FAILURE,
  DELETE_PRINTER_REQUEST,
  DELETE_PRINTER_SUCCESS,
  DELETE_PRINTER_FAILURE,
} from "./PrinterActionType";

const initialState = {
  PrinterData: [],
  loading: false,
  error: null,
};

const PrinterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRINTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PRINTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PrinterData: action.payload.data,
      };
    case FETCH_PRINTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        PrinterData: [],
      };

    case CREATE_PRINTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_PRINTER_SUCCESS:
      return {
        ...state,
        loading: false,
        PrinterData: action.payload.data,
        error: null,
      };
    case CREATE_PRINTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRINTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_PRINTER_SUCCESS:
      return {
        ...state,
        loading: false,
        PrinterData: action.payload.data,
        error: null,
      };
    case UPDATE_PRINTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRINTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_PRINTER_SUCCESS:
      return {
        ...state,
        loading: false,
        PrinterData: action.payload.data,
        error: null,
      };
    case DELETE_PRINTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default PrinterReducer;
